/**
 * Mirrors App\Support\ScopeAlgebra::missing — read/manage are alternatives.
 */
export function missingScopes(required: string[], granted: string[]): string[] {
  const set = new Set(granted);
  const groups = new Map<string, string[]>();
  for (const scope of required) {
    const key = scope.replace(':read:', ':*:').replace(':manage:', ':*:');
    const list = groups.get(key) ?? [];
    list.push(scope);
    groups.set(key, list);
  }
  const missing: string[] = [];
  for (const alts of groups.values()) {
    const ok = alts.some((scope) => {
      if (set.has(scope)) return true;
      if (scope.includes(':read:') && set.has(scope.replace(':read:', ':manage:'))) return true;
      if (scope.includes(':manage:') && set.has(scope.replace(':manage:', ':read:'))) return true;
      return false;
    });
    if (!ok) missing.push(alts[0]!);
  }
  return missing;
}
